import axios from "axios";
import CONSTANTS from "./constants";
import getAxiosConfig from "@src/utils/getAxiosConfig";
import apiEndPoints from "./apiEndPoints";

const shortUniqueInt = () => Math.floor(Date.now() % 1e8) * 10000 + Math.floor(Math.random() * 10000);

// AXIOS SERVICE TO GET COURSE CONTENT
export const getCourseContentService = (payload) => {
  return axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.GET_COURSE_CONTENT]?.method,
      apiEndPoints[CONSTANTS.GET_COURSE_CONTENT]?.url,
      payload
    ),
  });
};

// AXIOS SERVICE TO GET COURSE CONTENT
export const getTrialCourseContentService = (payload) => {
  return axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.GET_TRIAL_COURSE_CONTENT]?.method,
      apiEndPoints[CONSTANTS.GET_TRIAL_COURSE_CONTENT]?.url,
      payload
    ),
  });
};

// AXIOS SERVICE TO GET FREE COURSE CONTENT
export const getFreeCourseContentService = (payload) => {
  return axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.GET_FREE_COURSE_CONTENT]?.method,
      apiEndPoints[CONSTANTS.GET_FREE_COURSE_CONTENT]?.url,
      payload
    ),
  });
};

// AXIOS SERVICE TO GET ATTACHMENTS FOR A CONTENT ITEM
export const getContentAttachmentsService = (payload) => {
  return axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.GET_CONTENT_ATTACHMENTS]?.method,
      apiEndPoints[CONSTANTS.GET_CONTENT_ATTACHMENTS]?.url,
      payload
    ),
  });
};

// AXIOS SERVICE TO GET SUBJECTIVE TEST DOWNLOAD URL
export const getSubjectiveTestDownloadUrlService = (payload) => {
  return axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.GET_SUBJECTIVE_TEST_DOWNLOAD_URL]?.method,
      apiEndPoints[CONSTANTS.GET_SUBJECTIVE_TEST_DOWNLOAD_URL]?.url,
      payload
    ),
  });
};

// AXIOS SERVICE TO GET TEST STATS
export const getCourseContentTestStatsService = (payload) => {
  return axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.GET_COURSE_CONTENT_TEST_STATS]?.method,
      apiEndPoints[CONSTANTS.GET_COURSE_CONTENT_TEST_STATS]?.url,
      payload
    ),
  });
};

// AXIOS SERVICE TO GET TEST LEADERBOARD STATS
export const getTestLeaderboardStatsService = (payload) => {
  return axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.GET_TEST_LEADERBOARD_STATS]?.method,
      apiEndPoints[CONSTANTS.GET_TEST_LEADERBOARD_STATS]?.url,
      payload
    ),
  });
};

export const getTestbookSubscribeService = (payload) => {
  return axios({
    ...getAxiosConfig(
      "GET",
      () => `/v2/course/tb/subscribed-test/tb-access?testId=${payload.testId}&courseId=${payload.courseId}&contentId=${payload.contentId}`,
    ),
  });
}

export const idfyPrepurchaseOtpGenerateService = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.IDFY_PREPURCHAGE_OTP_GENERATE_SERVICE]?.method,
      apiEndPoints[CONSTANTS.IDFY_PREPURCHAGE_OTP_GENERATE_SERVICE]?.url,
      (payload = payload?.payload),
      null,
      null,
      null,
      { "device-id": shortUniqueInt() }
    ),
  });
};

export const idfyPrepurchaseOtpResendService = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.IDFY_PREPURCHAGE_OTP_RE_GENERATE_SERVICE]?.method,
      apiEndPoints[CONSTANTS.IDFY_PREPURCHAGE_OTP_RE_GENERATE_SERVICE]?.url,
      (payload = payload?.payload),
      null,
      null,
      null,
      { "device-id": shortUniqueInt() }
    ),
  });
};

export const idfyPrepurchaseOtpVerifyService = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.IDFY_PREPURCHAGE_OTP_VERIFY_SERVICE]?.method,
      apiEndPoints[CONSTANTS.IDFY_PREPURCHAGE_OTP_VERIFY_SERVICE]?.url,
      payload
    ),
  });
};

export const idfyPostPurchageIdentityVerifyService = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.IDFY_POSTPURCHAGE_IDENTITY_VERIFY_SERVICE]?.method,
      apiEndPoints[CONSTANTS.IDFY_POSTPURCHAGE_IDENTITY_VERIFY_SERVICE]?.url,
      payload
    ),
  });
};

export const polingSubmitIdfyDocService = (payload) => {
  const { orgId, courseId } = payload?.data;
  return axios({
    ...getAxiosConfig(
      "GET",
      () => `/v3/course/student/kyc/status?orgId=${orgId}&courseId=${courseId}`
    ),
  });
};